import { FC, PropsWithChildren } from "react";
import { useParams } from "react-router-dom";
import MriImageUploadsContext from "../../../hooks/context/MriImageUploadsContext";
import useGetIMriImageUploads from "../../../hooks/useGetIMriImageUploads";

export interface IMriImageUploadsProviderProps {
    selectedImagesNotUploaded?: boolean | undefined;
    selectedImagesNotVerified?: boolean | undefined;
    selectedImagesDeidentifiedFailed?: boolean | undefined;
    selectedImagesLegacy?: boolean | undefined;
}

export const MriImageUploadsProvider: FC<PropsWithChildren<IMriImageUploadsProviderProps>> = ({
    selectedImagesNotUploaded,
    selectedImagesNotVerified, 
    selectedImagesDeidentifiedFailed,
    selectedImagesLegacy,
    children
}) => {
    const institutionCode = useParams()?.institutionCode;

    const MriImageUploads = useGetIMriImageUploads(
        institutionCode, 
        selectedImagesNotUploaded, 
        selectedImagesNotVerified, 
        selectedImagesDeidentifiedFailed, 
        selectedImagesLegacy,
    );

    return (
        <MriImageUploadsContext.Provider value={MriImageUploads}>
            {children}
        </MriImageUploadsContext.Provider>
    );
}

export default MriImageUploadsProvider;
